import classNames from "classnames";
import React, { HTMLAttributes, ReactNode } from "react";
import style from "../../scss/export.module.scss";
import "./skeleton.scss";

type TSkeletonShade = "light" | "medium" | "dark";

export interface TSkeleton extends HTMLAttributes<HTMLDivElement> {
    width?: string;
    height?: string;
    borderRadius?: string;
    shade?: TSkeletonShade;
}

const shadeMap = {
    light: style.lightGreyColor,
    medium: style.greyColor,
    dark: style.darkGreyColor,
};

export const Skeleton = ({
    width = "100%",
    height = "25px",
    borderRadius = "6px",
    shade = "medium",
    ...props
}: TSkeleton) => {
    const style = { ...props.style, width, height, borderRadius, background: shadeMap[shade] };

    return <div {...props} className={classNames("c-skeleton", props.className)} style={style}></div>;
};

export const SkeletonGroup = ({ children }: { children: ReactNode }) => {
    return <div className="c-skeleton-group">{children}</div>;
};

export type TParagraphSkeleton = {
    shade?: TSkeletonShade;
};

export const ParagraphSkeleton = ({ shade = "medium" }: TParagraphSkeleton) => {
    return (
        <>
            <Skeleton shade={shade} style={{ marginBottom: "6px" }} />
            <Skeleton shade={shade} width="85%" style={{ marginBottom: "6px" }} />
            <Skeleton shade={shade} width="60%" />
        </>
    );
};

export type TButtonSkeleton = {
    shade?: TSkeletonShade;
    width?: string;
};

export const ButtonSkeleton = ({ shade = "medium", width = "140px" }: TButtonSkeleton) => {
    return (
        <>
            <Skeleton shade={shade} height="48px" width={width} />
        </>
    );
};

export const InputSkeleton = ({ shade = "medium" }: TButtonSkeleton) => {
    return (
        <SkeletonGroup>
            <Skeleton shade={shade} height="24px" width="100px" className="u-mb-6" />
            <Skeleton shade={shade} height="48px" />
        </SkeletonGroup>
    );
};

export const TableSkeleton = () => {
    return (
        <SkeletonGroup>
            <Skeleton height={"30px"} borderRadius="0" shade={"dark"} />
            {[...Array(10)].map((_, index) => (
                <Skeleton key={index} height="36px" borderRadius="0" shade={index % 2 === 0 ? "light" : undefined} />
            ))}
        </SkeletonGroup>
    );
};
